/**
 * @jsxRuntime classic
 * @jsx jsx
 *
 * TODO: GRAPHYTE-2511 wire up real destinations and behaviour for the
 * interactive elements in this section (the terminal-language dropdown,
 * the "Copy to clipboard" buttons, and the "View docs" buttons). All of
 * them are presentational only today.
 */
import { useState, Fragment } from 'react';

import { cssMap, jsx } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import gridBackground from '../../../../assets/grid-background.svg';
import { SectionName } from '../../../../common/analytics/section-name';
import { useSectionReveal } from '../../../../common/analytics/useSectionReveal';
import { NAV_BAR_HEIGHT_PX } from '../../NavBar';

import { TerminalWindow } from './CLI/TerminalWindow';
import { WorksWith } from './CLI/WorksWith';
import { McpTerminal } from './MCP/McpTerminal';
import { McpTools } from './MCP/McpTools';
import { SectionHeader } from './SectionHeader';
import { type Tab } from './TabToggle';

const styles = cssMap({
	section: {
		width: '100%',
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
		paddingBlock: '120px',
		backgroundSize: '60px 60px',
		backgroundRepeat: 'repeat',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
		scrollMarginTop: `${NAV_BAR_HEIGHT_PX}px`,
	},
	content: {
		width: '100%',
		maxWidth: '1200px',
		marginInline: 'auto',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		paddingInline: token('space.0'),
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
		backgroundColor: '#111213',
		'@media (max-width: 48rem)': {
			paddingInline: token('space.400'),
		},
	},
	divider: {
		width: '100%',
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
		borderBlockStart: '1px dotted #505258',
	},
	terminalBlock: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
		minHeight: '600px',
		paddingInline: token('space.500'),
	},
});

export const GettingStartedSection = (): JSX.Element => {
	const [selectedTab, setSelectedTab] = useState<Tab>('cli');
	const isMcp = selectedTab === 'mcp';
	const sectionRef = useSectionReveal<HTMLElement>(SectionName.GettingStarted);

	return (
		<section
			id="cli-1"
			ref={sectionRef}
			css={styles.section}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
			style={{ backgroundImage: `url(${gridBackground})` }}
		>
			<div css={styles.content}>
				<SectionHeader selectedTab={selectedTab} onSelectTab={setSelectedTab} />
				<div css={styles.divider} />
				{isMcp ? (
					<Fragment>
						<McpTerminal />
						<McpTools />
					</Fragment>
				) : (
					<Fragment>
						<div css={styles.terminalBlock}>
							<TerminalWindow />
						</div>
						<div css={styles.divider} />
						<WorksWith />
					</Fragment>
				)}
			</div>
		</section>
	);
};
